import React from "react";
import { Button, Modal } from "react-bootstrap";

const NotesModal = ({ show, onClose, note }) => {
  console.log(note, "note32211121212");

  return (
    <Modal
      show={show}
      onHide={() => onClose(false)}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title
          className="font_500 text-dark mb-0"
          style={{ fontSize: 16 }}
        >
          Notes
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="p-2">
          <p className="text-dark mb-0" style={{ fontSize: 14 }}>
            {note?.[0]?.notes || "No notes available."}
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={() => onClose(false)}
          //   className="d-flex align-items-center justify-content-center w-100"
          className={`submit-btn d-inline-flex justify-content-center `}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotesModal;
